export default [
  {
    path: '/entrance/external', // 获取授权
    name: 'TURNING',
    component: () => import('@/views/entrance/turning'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/regulations',
    name: 'REGULATIONS',
    component: () => import('@/views/encourageHome/regulations'),
    meta: {
      title: '活动规则',
      loginNo: true
    }
  },
  {
    path: '/entrance/paymentBackDemo', // 支付回调demo
    name: 'PAYMENTBACKDEMO',
    component: () => import('@/views/entrance/paymentBackDemo'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/entrance/authorizedBenefits', // 推送授权页
    name: 'AUTHORIZEDBENEFITS',
    component: () => import('@/views/entrance/authorizedBenefits'),
    meta: {
      title: '授权'
    }
  },
  {
    path: '/entrance/teleCounseling', // 电话咨询
    name: 'TELECOUNSELING',
    component: () => import('@/views/entrance/teleCounseling')
  },
  {
    path: '/orderDevice/receiveGifts', // 品牌月活动 赠品领取
    name: 'RECEIVEGIFTS',
    component: () => import('@/views/orderDevice/receiveGifts'),
    meta: {
      title: '品牌月活动'
    }
  },
  {
    path: '/entrance/shortChain/:id?', // 短链接 跳转的中间页
    name: 'SHORTCHAIN',
    component: () => import('@/views/entrance/shortChain'),
    meta: {
      loginNo: true
    }
  },
  // 云南线上运营抽奖活动
  {
    path: '/encourageHome',
    redirect: {
      path: '/entrance/external',
      query: { entranceType: 'yunnan_activity_lottery' }
    }
  },
  {
    path: '/activity/lottery',
    name: 'ENCOURAGEHOME',
    component: () => import('@/views/encourageHome/index'),
    meta: {
      title: '抽奖',
      loginNo: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/entrance.js